'use client'

import { useContext } from 'react'

import { SessionContext } from 'next-auth/react'

const ADMIN_ROLES = ['admin', 'sebrae_admin']

/**
 * Diz se a sessão atual é de um administrador, lendo o SessionContext direto em
 * vez de `useSession()`.
 *
 * A diferença importa: `useSession()` LANÇA fora de um <SessionProvider>, e este
 * hook alimenta um afford opcional de admin espalhado por cards de conteúdo. Um
 * botão que só admin vê não pode derrubar a árvore de quem renderiza aqueles
 * cards sem provider — sem sessão, a resposta correta é "não é admin", não um
 * erro.
 */
export const useIsAdmin = (): boolean => {
  const session = useContext(SessionContext)

  const roles = session?.data?.user?.roles

  if (!roles) return false

  return roles.some(role => ADMIN_ROLES.includes(role.slug))
}
